export function formatUserDocumentPublic(document) {
  if (!document) {
    return null;
  }
  let formattedDocument = {};
  formattedDocument.id = document.id;
  // Projection model: the public doc carries birthday iff the owner made it
  // visible. birthdayVisible itself is an owner-only preference that lives
  // only on privateInfo and never appears on the public doc.
  formattedDocument.birthday = document.birthday ? document.birthday : null;
  formattedDocument.displayName = document.displayName;
  formattedDocument.username = document.username;
  formattedDocument.profilePicture = document.profilePicture;
  formattedDocument.createdAt = document.createdAt.toDate();
  formattedDocument.lastUpdated = document.lastUpdated.toDate();
  // emailVerificationLastSentTime is account-internal metadata and is exposed
  // only via formatUserDocumentPrivate — it is intentionally omitted from the
  // public projection that other users can read.
  return formattedDocument;
}

export function formatUserDocumentPrivate(document) {
  if (!document) {
    return null;
  }
  let formattedDocument = {};
  formattedDocument.email = document.email;
  formattedDocument.emailVerified = document.emailVerified;
  formattedDocument.emailVerificationLastSentTime =
    document.emailVerificationLastSentTime
      ? document.emailVerificationLastSentTime.toDate()
      : null;
  formattedDocument.birthday = document.birthday ? document.birthday : null;
  // Owner-only visibility preference (projection model): every privateInfo doc
  // carries it — seeded at signup, back-filled by the 2026-07 migration.
  // Deliberately NOT an override key in mergeTwoObjects (the `||` fallback
  // would mangle `false`).
  formattedDocument.birthdayVisible = document.birthdayVisible;
  formattedDocument.displayName = document.displayName
    ? document.displayName
    : null;
  formattedDocument.profilePicture = document.profilePicture
    ? document.profilePicture
    : null;
  // Which option the user selected as their avatar ("default" or a provider id),
  // used to pre-check the right radio in the profile-picture picker.
  formattedDocument.profilePictureSource = document.profilePictureSource
    ? document.profilePictureSource
    : "default";
  formattedDocument.approvedProviders = [];
  document.approved_providers.forEach((provider) => {
    formattedDocument.approvedProviders.push({
      provider: provider.provider,
      email: provider.email,
      profilePicture: provider.profilePicture,
    });
  });

  return formattedDocument;
}
